import { createAction, ActionsUnion } from "../definitions";
import { GroupLinkedDeviceActionTypes } from "./types";
import GroupLinkedDevice from "../../model/GroupLinkedDevice";

export interface IGroupLinkedDevicePayload {
    deviceId: string;
    groupLinkedDevices: IIdDictionary<GroupLinkedDevice>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GroupLinkedDeviceActions = {
    clearGroupLinkedDevices: () => createAction(GroupLinkedDeviceActionTypes.CLEAR_GROUPLINKEDDEVICES),
    setGroupLinkedDevices: (payload: IGroupLinkedDevicePayload) => createAction(GroupLinkedDeviceActionTypes.SET_GROUPLINKEDDEVICES, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type GroupLinkedDeviceActions = ActionsUnion<typeof GroupLinkedDeviceActions>;